import { render, staticRenderFns } from "./other_attrs.vue?vue&type=template&id=76ed3578&scoped=true"
import script from "./other_attrs.vue?vue&type=script&lang=js"
export * from "./other_attrs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ed3578",
  null
  
)

export default component.exports